module.exports = require('./helpers/bundle-url').getBundleURL('5v461') + "bankid-phone.123690f1.svg";